import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function CTASection() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setSubmitted(true);
      setEmail('');
      setTimeout(() => setSubmitted(false), 3000);
    }
  };

  return (
    <section className="py-20 md:py-28 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=soft%20dreamy%20night%20sky%20with%20stars%20and%20gentle%20moonlight%2C%20peaceful%20atmosphere%2C%20warm%20cream%20and%20deep%20navy%20tones%2C%20minimalist%20aesthetic%2C%20cinematic%20photography%2C%20soft%20bokeh%20effect%2C%20tranquil%20mood&width=1800&height=800&seq=cta-bg-01&orientation=landscape"
        alt="助眠 ASMR 订阅"
        title="订阅助眠 ASMR 内容更新"
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/40" />

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          开启您的<strong className="text-primary-300">深度睡眠</strong>之旅
        </h2>
        <p className="text-sm md:text-base text-background-50/75 mb-8 max-w-xl mx-auto">
          订阅眠境助眠 ASMR 内容更新，获取最新的助眠音频推荐与睡眠改善技巧
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto">
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入您的邮箱地址"
            required
            className="w-full px-5 py-3 rounded-full text-sm bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 placeholder:text-background-50/50 focus:outline-none focus:border-primary-400 transition-colors"
          />
          <button
            type="submit"
            className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap flex-shrink-0 cursor-pointer"
          >
            {submitted ? '已订阅 ✓' : '免费订阅'}
          </button>
        </form>

        <p className="mt-4 text-xs text-background-50/50">
          订阅即表示您同意接收眠境的助眠内容更新邮件
        </p>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer no-underline"
          >
            浏览 ASMR 分类
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/10 hover:bg-background-50/20 backdrop-blur-sm text-background-50 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer border border-background-50/30 no-underline"
          >
            了解眠境
          </Link>
        </div>
      </div>
    </section>
  );
}